import { useTranslate } from "@similarweb/i18n-provider";
import { Alerts } from "@similarweb/icons";
import { colorsPalettes } from "@similarweb/styles";
import { IconButton } from "@similarweb/ui-components";
import { Flex, Text } from "@similarweb/ui-components/foundations";

import {
    MANAGEMENT_INTEGRATION_SF_ACTIVITY_BANNER_BUTTON,
    MANAGEMENT_INTEGRATION_SF_ACTIVITY_BANNER_TEXT,
} from "../../../../common-components/export-table/translations";

import { StyledSalesforceActivityBannerFlex } from "./styles";

const BANNER_BUTTON_LINK = "https://www.similarweb.com/corp/legal/supplemental-terms-conditions-sales-intelligence/";

export const SalesforceActivityBanner = () => {
    const { translate } = useTranslate();

    return (
        <StyledSalesforceActivityBannerFlex
            justifyContent="space-between"
            alignItems="center"
            data-automation="salesforce-activity.cnt-banner"
        >
            <Flex
                gap="8px"
                alignItems="center"
            >
                <Alerts size="sm" />
                <Text
                    fontVariant="body1"
                    color={colorsPalettes.carbon["400"]}
                >
                    {translate(MANAGEMENT_INTEGRATION_SF_ACTIVITY_BANNER_TEXT)}
                </Text>
            </Flex>

            <IconButton
                iconName="link-out"
                type="flat"
                placement="right"
                dataAutomation="salesforce-activity.cnt-banner.guide-link"
                onClick={() => window.open(BANNER_BUTTON_LINK, "_blank", "noopener,noreferrer")}
            >
                {translate(MANAGEMENT_INTEGRATION_SF_ACTIVITY_BANNER_BUTTON)}
            </IconButton>
        </StyledSalesforceActivityBannerFlex>
    );
};
